// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { SHOP_ADMINISTRATION_USERS_URL } from './user.constants';
import { ShopAdministrator } from './shop-administrator.interface';
import { SwitchCurrentUserShopParam } from './switch-current-user-shop-param.interface';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';

/**
 * Associates the current global admin with another shop api
 */
export const switchCurrentUserShop = (param: SwitchCurrentUserShopParam): Promise<AxiosResponse<ShopAdministrator>> => {
  const url = `${API_COMMON_BASE_URL}/${SHOP_ADMINISTRATION_USERS_URL}/me/shop`;

  return axios.put(url, param);
};
